/**
* Form with Sticky Image JS
* -----------------------------------------------------------------------------
*
* All the JS for the Form with Sticky Image component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'form-with-sticky-image',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const stickyImageHeight = $( '.sticky-image__top .aspect-square' ).height();
      $( ':root' ).css( '--stickyImageHeight', `${stickyImageHeight}px` );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'form-with-sticky-image', COMPONENT );
} )( app );
